var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"custom-checkbox"},[_c('input',{class:_vm.className,attrs:{"type":"checkbox","name":_vm.name,"id":_vm.id,"required":_vm.required},on:{"change":_vm.updateInput}}),_c('label',{staticClass:"fs-small font-weight-bold",attrs:{"for":_vm.id}},[_vm._v(_vm._s(_vm.label))])])
}
var staticRenderFns = []

export { render, staticRenderFns }